import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { templateSuccess } from '../../constants/templateSuccess';
import { StepperService } from '@core/stepper/stepper.service';
import { smoothscroll } from 'smoothscroll-polyfill';
import { ActionPlanServices } from '@core/action-plan/action-plan.services';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogCommentComponent } from '../dialog-comment/dialog-comment.component';
import { TooltipPosition } from '@angular/material/tooltip';
import { MessageToastService } from '@core/messages/message-toast.service';

export interface ActionPlanTableElement {
  idAction: string;
  item_id: number;
  finding: string;
  recommendation: string;
  commentsIDB: string;
  comments: string;
  action: string;
  responsible: string;
  endLimitTime: string;
  limitTime: string;
  meansV: string;
  actionMatrixStatus: string;
  initLimitTime: string;
  clone: boolean;
  verificationMeans: string;
  status: string;
  isExpanded: boolean;
  statusImplementation: string;
  dateImplementation: string;

  actionPlanIdClone: string;
  statusActionImplement: string;
  commentsImplementation: string;
  commentStatusCompleted: string;
  commentStatusInProgress: string;
  commentsActionEGF: string;
  commentsActionOE: string;
  dateStatusCompleted: string;
  dateStatusInProgress: string;
  indexClone: number;
  definedActions: string;
}

@Component({
  selector: 'bid-action-plan-table',
  templateUrl: './action-plan-table.component.html',
  styleUrls: ['./action-plan-table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ActionPlanTableComponent implements OnInit {
  @Input() tableButtons = true;
  @Input() language;
  @Input() scoreScreen = false;
  @Input() operationNumber;
  @Output() actionPlans = new EventEmitter();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  positionOptions: TooltipPosition[] = ['after', 'before', 'above', 'below', 'left', 'right'];
  position = new FormControl(this.positionOptions[0]);
  isDataComplete = false;
  VisibleSubmit = false;
  isApproveOrReject = false;
  isTableExpanded = false;
  disabledButton: boolean;
  templateSuccess = templateSuccess;
  dataSource: any;
  estimateDate: FormGroup;
  activeSubmit = false;
  ELEMENT_DATA: ActionPlanTableElement[] = [];
  itemOption = new FormControl('In process');
  actionPlansByOperationNumber;
  selectedPage;
  numPage = [0];
  minDate: Date;
  maxDate: Date;
  isMyActionPlan = false;
  isNotify = false;
  isReject = true;
  states: any[] = [
    {
      id: 1,
      name: 'Pendiente',
    },
    {
      id: 1,
      name: 'En proceso',
    },
    {
      id: 1,
      name: 'Finalizado',
    },
  ];
  displayedColumns: string[] = [
    'item_id',
    'finding',
    'recommendation',
    'comments',
    'actionsDE',
    'responsable',
    'estimatedID',
    'meansV',
    'statusI',
    'semaphore',
    'managementAP',
    'ComentsOE',
    'ComentsEGF',
  ];
  msgs = [];
  rolUser: any;
  listStatus = [];
  pageSize = 0;
  STEP1 = [
    { name: 'loadActionPlan', stepSelected: false, disabled: false },
    { name: 'updateActionPlan', stepSelected: false, disabled: false },
    { name: 'myActionPlan', stepSelected: false, disabled: false },
  ];
  disableSubmmit = false;

  constructor(
    private stepperService: StepperService,
    private actionPlanServices: ActionPlanServices,
    private spinner: NgxSpinnerService,
    private messageService: MessageService,
    private router: Router,
    private dialog: MatDialog,
    private messageToastService: MessageToastService,
  ) {
    this.minDate = new Date();
    this.maxDate = new Date(this.minDate);
    this.maxDate.setMonth(11);
    this.maxDate.setDate(31);
  }

  ngOnInit() {
    if (this.router.url == '/MyActionPlan') this.isMyActionPlan = true;
    this.stepperService.setStepper(this.STEP1);
    this.disabledButton = true;
    this.getRolUser();
    const today = new Date();
    this.estimateDate = new FormGroup({
      start: new FormControl(new Date(today.getFullYear(), today.getMonth(), 13)),
      end: new FormControl(new Date(today.getFullYear(), today.getMonth(), 13)),
    });
    this.listStatus = [
      { value: 'To implement', label: 'To implement' },
      { value: 'In progress', label: 'In Progress' },
      { value: 'Complete', label: 'Complete' },
    ];
    this.configTable();
  }

  showSubmit(status) {
    this.spinner.show();
    this.updateActionPlanToApprove(status);
  }

  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0 && day !== 6;
  };

  backToTop() {
    smoothscroll.polyfill();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  filtrar(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filtro.trim().toLowerCase();
  }

  ngOnChanges() {
    this.getActionPlan(this.operationNumber.value);
  }

  getActionPlan(value) {
    if (value) {
      console.log('value', value);
      this.spinner.show();
      this.actionPlanServices.getActionPlanByOperationNumber(value).subscribe({
        next: (res: any) => {
          this.actionPlansByOperationNumber = res;
          console.log(this.actionPlansByOperationNumber);
          if (res) {
            this.ELEMENT_DATA = [];
            this.dataSource = [];

            this.ELEMENT_DATA = res.map((item: ActionPlanTableElement, index) => {
              return {
                idAction: item.idAction,
                item_id: index + 1,
                finding: item.finding,
                recommendation: item.recommendation,
                commentsIDB: item.commentsIDB,
                comments: item.commentsIDB,
                action: item.action,
                responsible: item.responsible,
                endLimitTime: item.endLimitTime,
                limitTime: item.limitTime,
                meansV: item.verificationMeans,
                actionMatrixStatus: item.actionMatrixStatus,
                initLimitTime: item.initLimitTime,
                clone: item.clone,
                verificationMeans: item.verificationMeans,
                status: item.status,
                isExpanded: false,
                statusImplementation: item.statusImplementation,
                dateImplementation: item.dateImplementation,
                commentsImplementation: item.commentsImplementation,
                actionPlanIdClone: item.actionPlanIdClone,
                statusActionImplement: item.statusActionImplement,
                commentStatusCompleted: item.commentStatusCompleted,
                commentStatusInProgress: item.commentStatusInProgress,
                commentsActionEGF: item.commentsActionEGF,
                commentsActionOE: item.commentsActionOE,
                dateStatusCompleted: item.dateStatusCompleted,
                dateStatusInProgress: item.dateStatusInProgress,
                indexClone: item.indexClone,
                definedActions: item.definedActions,
              };
            });

            this.ELEMENT_DATA = this.ELEMENT_DATA.sort((a, b) => {
              if (a.indexClone > b.indexClone) return 1;
              if (a.indexClone < b.indexClone) return -1;
              return 0;
            });

            this.selectedPage = [];
            this.numPage = [];

            this.pageSize = this.ELEMENT_DATA.length;
            this.ELEMENT_DATA.forEach((item, index) => this.numPage.push(index + 1));
            this.selectedPage = this.numPage;

            this.dataSource = new MatTableDataSource<ActionPlanTableElement>(this.ELEMENT_DATA);
            this.dataSource.paginator = this.paginator;
            if (
              this.dataSource._data._value.some((item) => {
                return !item.responsible || !item.definedActions || !item.verificationMeans;
              }) ||
              this.operationNumber.status != 'Required'
            ) {
              this.isApproveOrReject = false;
            } else {
              this.isApproveOrReject = true;
            }
            this.isDataComplete = true;
            let complets = 0;
            res.forEach((element) => {
              if (
                element.definedActions == '' ||
                element.responsible == '' ||
                element.verificationMeans == '' ||
                element.definedActions == undefined ||
                element.responsible == undefined ||
                element.verificationMeans == undefined
              ) {
                this.isDataComplete = false;
              }
              if (element.status == 'Complete') {
                complets = complets + 1;
              }
            });
            if (complets == res.length) {
              this.operationNumber.status = 'Complete';
            }
          }
          this.spinner.hide();
          this.actionPlans.emit(this.dataSource);
        },
        error: (error) => {
          this.spinner.hide();
        },
      });
    }
  }

  addActionPlan(id) {
    console.log('id', id);
    this.actionPlanServices.getCloneActionPlan(id).subscribe({
      next: (resultado: any) => {
        this.getActionPlan(this.operationNumber.value);
      },
      error: (error: any) => {},
    });
  }

  deleteActionPlan(id) {
    this.actionPlanServices.deleteCloneActionPlan(id).subscribe({
      next: (resultado: any) => {
        this.getActionPlan(this.operationNumber.value);
      },
      error: (error: any) => {},
    });
  }

  statusChange(i, event) {
    this.dataSource[i].verificationMeans = event.value.name;
  }

  dateChange(i, event) {
    console.log('event', event);
  }

  getRolUser() {
    this.rolUser = JSON.parse(localStorage.getItem('rolUserLocalStorage'));
    console.log('this.rolUser', this.rolUser);
  }

  updateActionPlanApprove() {
    this.dataSource._data.value.map((item) => {
      item.status = 'In Progress';
    });
    this.isApproveOrReject = false;
    this.operationNumber.status = 'Remitted';
    var obj = {
      statusAP: 'Remitted',
      idActionPlan: this.operationNumber.value,
      actionPlans: this.dataSource._data.value,
    };
    this.updateActionPlan(obj);
  }

  updateActionPlanToApprove(status) {
    var obj = {
      statusAP: status,
      idActionPlan: this.operationNumber.value,
      actionPlans: this.dataSource._data.value,
    };
    this.updateActionPlan(obj);
  }
  confirmFR() {
    var obj = {
      statusAP: 'In Process',
      idActionPlan: this.operationNumber.value,
      actionPlans: this.dataSource._data.value,
    };
    this.updateActionPlan(obj);
  }

  SaveActionPlanFR() {
    this.operationNumber.status = 'Observed';
    var obj = {
      statusAP: this.operationNumber.status,
      idActionPlan: this.operationNumber.value,
      actionPlans: this.dataSource._data.value,
    };
    this.updateActionPlan(obj);
  }

  updateActionPlan(dataJson) {
    var mensaje = {};

    this.spinner.show();
    this.actionPlanServices.upDateActionPlan(dataJson).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (dataJson.statusAP == 'Remitted') {
          this.showSuccessMessage('Action plan has been approved.');
        } else {
          this.showSuccessMessage('Action plan saved.');
        }
        this.operationNumber.status = dataJson.statusAP;
        this.getActionPlan(this.operationNumber.value);
      },
      error: (error) => {
        this.spinner.hide();
      },
    });
  }
  showSuccessMessage(message) {
    this.messageToastService.showToastSuccess('Message', message, 'successMessage');
  }
  showErrorMessage(message) {
    this.messageToastService.showToastError('Message', message, 'errorMessage');
  }

  configTable() {
    if (this.rolUser.role == 'OEG') {
      this.displayedColumns = [];
      this.displayedColumns = [
        'item_id',
        'finding',
        'recommendation',
        'comments',
        'actionsDE',
        'responsable',
        'estimatedID',
        'meansV',
        'statusI',
        'semaphore',
        'btnClone',
        'managementAP',
        'ComentsOE',
        'ComentsEGF',
      ];
    }
  }

  openDialogComment(comment) {
    const dialogRef = this.dialog.open(DialogCommentComponent, {
      width: '800px',
      data: { name: comment },
    });
  }

  validaIsNotify() {
    console.log('flag2');
    if (
      this.dataSource._data._value.some((item) => {
        return !item.responsible || !item.definedActions || !item.verificationMeans;
      })
    ) {
      this.isNotify = false;
    } else {
      this.isNotify = true;
    }
  }

  sendNotify(status) {
    this.spinner.show();
    this.updateActionPlanToApprove(status);
  }
}
